export { Header, HeaderProps } from './Header';
export { Footer, FooterProps } from './Footer';
export { Content, ContentProps } from './Content';
export { Footnote, FootnoteProps } from './Footnote';
export { Illustration, IllustrationProps } from './Illustration';
